"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _Button = _interopRequireDefault(require("../Button"));
var View = function View(_ref) {
  var open = _ref.open,
    isLoading = _ref.isLoading,
    onClose = _ref.onClose,
    onConfirm = _ref.onConfirm;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    fullWidth: true,
    maxWidth: "xs",
    open: open,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-10 pt-4 text-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-6xl text-red leading-relaxed"
  }, /*#__PURE__*/_react["default"].createElement(_Error["default"], {
    fontSize: "inherit"
  })), /*#__PURE__*/_react["default"].createElement("h3", {
    className: "text-2xl text-dark font-bold"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "w-2/3 inline-block"
  }, t('inboxBreak.scheduledBreak.remove.confirm'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "mt-10 flex items-center justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    onClick: onClose,
    disabled: isLoading,
    className: "w-40 mr-2"
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    onClick: onConfirm,
    disabled: isLoading,
    className: "w-40 ml-2"
  }, isLoading ? /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
    size: 24,
    color: "inherit"
  }) : t('button.yes')))));
};
var _default = exports["default"] = View;
//# sourceMappingURL=RemoveBreakConfirmation.js.map